var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { staticClass: "category-card", attrs: { href: _vm.link } }, [
    _c("div", { staticClass: "image-wrapper" }, [
      _c("img", {
        staticClass: "lazyload",
        attrs: { "data-src": _vm.image, alt: _vm.title }
      }),
      _vm._v(" "),
      _vm.isTop
        ? _c("span", { staticClass: "top-label" }, [_vm._v("Topaanbieding")])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-wrapper" }, [
      _c("h3", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.readMore)),
        _c("span", { domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) } })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }